import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';


const PrintSaveForm = ({ printTemplate, currentPrintTemplate, setPrintTemplate }) => {
  const handleTitleChange = (event) => {
    setPrintTemplate({ ...currentPrintTemplate, title: event.target.value });
  };

  const handleDescriptionChange = (event) => {
    setPrintTemplate({ ...currentPrintTemplate, message_content: event.target.value });
  };

  const handleOngoingChange = (event) => {
    setPrintTemplate({ ...currentPrintTemplate, ongoing: event.target.checked });
  };

  useEffect(() => {
    if (printTemplate) setPrintTemplate(printTemplate);
  }, [printTemplate]);

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Print Template Title"
            value={currentPrintTemplate?.title}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleTitleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="outlined-multiline-static"
            label="Description"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            value={currentPrintTemplate?.message_content}
            onChange={handleDescriptionChange} />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={<Checkbox
              onChange={handleOngoingChange}
              checked={Boolean(currentPrintTemplate?.ongoing)} />}
            label="Ongoing Template" />
        </Grid>
      </Grid>
    </>
  );
};


export default PrintSaveForm;